import React, { CSSProperties } from 'react';
import P, { InferProps } from 'prop-types';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import AlarmIcon from '@mui/icons-material/Alarm';
import { SxStyle, Field } from '../../../../types';
import { useStringsContext } from '../../../../contexts/strings';
import { MODULE_TYPES } from '../types';

const styles: SxStyle = {
  title: {
    marginRight: '6px',
  },
  promoChip: {
    '& .MuiChip-label': {
      lineHeight: '20px',
    },
  },
};

const getFieldValue = (fields: Field[], key: string) => {
  const field = fields.find((field) => field.key === key);
  return field ? field.value : null;
};

function PromoModuleTitle({
  title,
  type,
  fields,
  promos,
}: InferProps<typeof PromoModuleTitle.propTypes>) {
  const { strings } = useStringsContext();
  let promoValue = null;
  let promosIsTimed = false;

  if (promos) {
    if (type === MODULE_TYPES.PROMO || type === MODULE_TYPES.PROMO_VIDEO) {
      const promoIndex = getFieldValue(fields, 'promoIndex') as string;
      promoValue = promoIndex;
    } else if (type === MODULE_TYPES.PROMO_IMAGES) {
      const promoIndexes = getFieldValue(fields, 'promoIndexes') as string[];
      promoValue = promoIndexes?.join(', ');
    }
    const promosTimed = getFieldValue(fields, 'promosTimed') as string[] | null;
    promosIsTimed = !!promosTimed && promosTimed.length > 1;
  }

  return (
    <>
      <span style={styles.title as CSSProperties}>{title}</span>
      {promoValue && (
        <Tooltip
          arrow
          disableFocusListener
          disableTouchListener
          title={strings.promos.promoTooltip.replace('$promoValue', promoValue)}
          placement="top"
        >
          <Chip
            label={`Promo ${promoValue}`}
            size="small"
            variant="outlined"
            sx={styles.promoChip}
            icon={promosIsTimed ? <AlarmIcon /> : <></>}
          />
        </Tooltip>
      )}
    </>
  );
}

PromoModuleTitle.propTypes = {
  title: P.string.isRequired,
  type: P.string.isRequired,
  fields: P.arrayOf(P.any.isRequired).isRequired,
  promos: P.arrayOf(P.any),
};

export default PromoModuleTitle;
